import {
    ADISignInAssistModel,
    ADISignInAssistParamater,
    getUsernamePasswordAssistInfo,
} from "@NA/Services/ADISignInAssist";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { HasOnError, HasOnSuccess, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<ADISignInAssistParamater & HasOnSuccess & HasOnError, ADISignInAssistModel>;

export const setUsernamePasswordAssistInfo: HandlerType = async (props: any) => {
    props.apiResult = await getUsernamePasswordAssistInfo({
        userName: props.parameter.userName,
        eventName: props.parameter.eventName,
        eventDescription: props.parameter.eventDescription,
        uri: props.parameter.uri,
        properties: props.parameter.properties,
    });
};

export const chain = [setUsernamePasswordAssistInfo];

const signInAssist = createHandlerChainRunner(chain, "SignInAssist");
export default signInAssist;
